function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
  fill: "#F3F2F2"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6602 47.9511H18.5552C21.3311 47.9511 24.5407 45.3489 24.5407 41.9656V15.2392H16.9069C13.3503 15.2392 10.6602 17.4942 10.6602 21.3986V47.9511Z",
  fill: "#0F549D"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2759 47.9511H34.1709C36.9469 47.9511 40.1574 45.3489 40.1574 41.9656V15.2392H32.5226C28.9649 15.2392 26.2759 17.4942 26.2759 21.3986V47.9511Z",
  fill: "#B41F36"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M42.1079 47.9511H50.0029C52.7789 47.9511 55.9894 45.3489 55.9894 41.9656V15.2392H48.3552C44.7985 15.2392 42.1085 17.4942 42.1085 21.3986V47.951H42.1079V47.9511Z",
  fill: "#329947"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6281 32.5426H8.45996C9.06777 34.9719 11.9298 36.8813 15.1403 36.8813C18.0901 36.8813 22.0809 35.2321 22.0809 32.1089V26.4702H17.1356V32.1091C17.1356 33.7583 15.834 35.0594 14.0119 35.0594C12.3643 35.0589 10.8889 34.018 10.6281 32.5426Z",
  fill: "#F3F2F2"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M53.9142 33.6708C53.9142 34.9713 52.7874 36.0128 51.312 36.0128H40.3813V26.4695H51.312C52.6126 26.4695 53.7419 27.5977 53.7419 28.8994C53.7419 30.1999 52.6131 31.3287 51.312 31.3287C52.7874 31.3284 53.9142 32.3697 53.9142 33.6708ZM44.5448 30.808H47.9288C48.7964 30.808 49.577 30.0273 49.577 29.1588C49.577 28.2922 48.7964 27.5105 47.9288 27.5105H44.5448V30.808ZM48.0156 34.9715C48.8821 34.9715 49.6639 34.1908 49.6639 33.3232C49.6639 32.4556 48.8823 31.6749 48.0156 31.6749H44.5448V34.9709H48.0156V34.9715Z",
  fill: "#F3F2F2"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7659 34.3646V36.0129H29.4368C26.8346 36.0129 24.6655 33.8442 24.6655 31.2416C24.6655 28.6399 26.8346 26.4703 29.4368 26.4703H37.7659V28.2059C35.7705 27.7719 33.8606 27.5117 32.9066 27.5117C30.8254 27.5117 29.1772 29.16 29.1772 31.2421C29.1772 33.3243 30.8254 34.9726 32.9066 34.9726C33.8606 34.9715 35.7705 34.7986 37.7659 34.3646Z",
  fill: "#F3F2F2"
});
function SvgJcbCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbCard);
export default __webpack_public_path__ + "static/media/jcbCard.0edba622.svg";
export { ForwardRef as ReactComponent };